import { useFormik } from 'formik';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import Select from 'react-select';
import { Card } from '@components/card/card';
import { CardBody, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import SwalAlert from '@components/Shared/Alert/SwalAlert';
import { useNavigate, useParams } from 'react-router-dom';
import ButtonPrint from '@components/Print/ButtonPrint';
import Loading from '@components/Shared/Loader/Loading';
import { useEffect } from 'react';
import PRLines from './PRLines';

import {
  getPurchaseRequestById,
  cleanUpPurchaseRequestById,
  updatePurchaseRequest
} from '@store/purchases/PurchaseRequests/purchaseRequestsSlice';
import useGetCategoriesList from '@hooks/INV/useGetCategoriesList';
import { AddPurchaseRequestSchema } from '../../../ValidationForm/validationSchema';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
import { Can } from '@Permisstions/Can';

const Update = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { InventoryOptions } = useGetInventoryWithPermission();

  const { OperatingUnitOptions, loading: loading3 } = useGetOperatingUnitWithPermission();

  const { CategoriesOptions, loading: loading4 } = useGetCategoriesList();
  const { PurchaseRequestsById: data, loading: loading5 } = useAppSelector(s => s.PurchaseRequest);

  useEffect(() => {
    if (id) {
      dispatch(getPurchaseRequestById(id));
    }
    return () => {
      dispatch(cleanUpPurchaseRequestById());
    };
  }, [id]);

  //#region Formik
  const formik = useFormik({
    initialValues: {
      id: data ? data.id : '',
      code: data ? data.code : '',
      categoryId: data ? data.categoryId : '',
      // categoryId: '1E0C54A1-0D4C-4DBD-031F-08DC3D9EC802',

      organizationId: data ? data.organizationId : '',
      peopleId: data ? data.peopleId : '',
      recipientname: data ? data.recipientname : '',
      billToLocationId: data ? data.billToLocationId : '',
      shipToLocationId: data ? data.shipToLocationId : '',
      referenceId: data ? data.referenceId : '',
      transactionDate: data ? data.transactionDate?.split('T')[0] : '',
      deliveryDate: data ? data.deliveryDate?.split('T')[0] : '',
      expirationDate: data ? data.expirationDate : '',
      dueDate: data ? data.dueDate : '',
      paymentTermsId: data ? data.paymentTermsId : '',
      description: data ? data.description : '',
      grossAmount: data ? data.grossAmount : '',
      discountRate: data ? data.discountRate : '',
      discountAmount: data ? data.discountAmount : '',
      vat: data ? data.vat : '',
      netAmount: data ? data.netAmount : '',
      isAme: false,
      ameStatus: data ? data.ameStatus : 0,
      personId: data ? data.personId : '',
      contractId: data ? data.contractId : 'e',
      paymentTerms: data ? data.paymentTerms : '',
      deliveryTerm: data ? data.deliveryTerm : '',
      inventoryId: data ? data.inventoryId : '',
      waybill: data ? data.waybill : '',
      phone: data ? data.phone : '',
      currencyCode: data ? data.currencyCode : '',
      currencyConversionRate: data ? data.currencyConversionRate : '',
      batchId: data ? data.batchId : '',
      paymentMethodId: data ? data.batchId : '',
      transactionsLinesList:
        data?.transactionsLinesList?.map(item => ({
          id: item.id,
          // transactionId: item.transactionId,
          itemId: item.itemId,
          lineNumber: item.lineNumber,
          uom: item.uom,
          description: item.description,
          // price: item.price,
          qty: item.qty,
          // discountRate: item.discountRate,
          // discountAmount: item.discountAmount,
          // vatRate: item.vatRate,
          // total: item.total,
          // vatAmount: item.vatAmount,
          // unitCost: item.unitCost,
          // codeCombinationId: item.codeCombinationId,
          // currencyCode: item.currencyCode,
          // currencyConversionRate: item.currencyConversionRate,
          // lotId: item.lotId,
          // headerId: item.headerId,
          // lineId: item.lineId,
          inventoryId: item.inventoryId,
          // type: item.itemId === null ? 'Non_Inv' : 'Inv'
          itemType: item.itemId === null ? 'UndefinedItem' : item.itemType
        })) || []
    },

    enableReinitialize: true,
    validationSchema: AddPurchaseRequestSchema(t),
    onSubmit: values => {
      const { transactionsLinesList, ...restValues } = values;

      // const grossSale = values.transactionsLinesList.reduce(
      //   (s, a) => Number(s) + Number(a.total),
      //   0
      // );

      if (values.transactionsLinesList?.length === 0) {
        SwalAlert({ text: 'أدخل أصناف' });
        formik.setSubmitting(false);

        return;
      }

      dispatch(
        updatePurchaseRequest({
          id: values.id,

          organizationId: values.organizationId,
          peopleId: values.peopleId,
          recipientname: values.recipientname,
          billToLocationId: null,
          shipToLocationId: null,
          referenceId: values.referenceId,
          transactionDate: values.transactionDate,
          deliveryDate: values.deliveryDate || null,
          expirationDate: values.expirationDate || null,
          dueDate: values.dueDate || null,
          paymentTermsId: null,

          description: values.description,
          // grossAmount: grossSale,
          // discountRate: values.discountRate || 0,
          // discountAmount: values.discountAmount || 0,
          // vat: values.vat || 0,
          // netAmount: values.netAmount || 0,
          contractId: values.contractId || null,
          // ameStatus: values.ameStatus || 0,

          // isAme: values.isAme || false,
          personId: values.personId,
          paymentTerms: values.paymentTerms,
          deliveryTerm: values.deliveryTerm,
          inventoryId: values.inventoryId,
          waybill: values.waybill,
          phone: values.phone,
          currencyCode: values.currencyCode,
          currencyConversionRate: values.currencyConversionRate || 0,
          batchId: values.batchId || null,
          paymentMethodId: values.paymentMethodId || null,
          categoryId: values.categoryId || null,
          transactionsLinesList: formik.values.transactionsLinesList?.map(item => ({
            id: item.id,
            transactionId: data.id,
            itemId: item.itemId,
            itemType: item.itemType,
            lineNumber: item.lineNumber,
            uom: item.uom,
            description: item.description,
            // price: Number(item.price),
            qty: Number(item.qty),
            // discountRate: Number(item.discountRate),
            // discountAmount: Number(item.discountAmount),
            // vatRate: Number(item.vatRate),
            // total: Number(item.total),
            // vatAmount: Number(item.vatAmount),
            // unitCost: Number(item.unitCost),
             // currencyCode: 'SAR',
            // currencyConversionRate: 0,
            // lotId: null,
            // headerId: null,
            // lineId: null,
            inventoryId: values.inventoryId
          }))
        })
      )
        .unwrap()
        .then((res: any) => {
          // debugger;
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Edit' });
            formik.resetForm();
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  const { values, handleChange: formikhandleChange, errors, touched } = formik;
  //#endregion

  // console.log(values.transactionsLinesList);

  //____________________________

  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'طلبات الشــراء',
              link: '/PUR/PurchaseRequests'
            },
            {
              name: ' تفاصيـل طلب الشراء',
              link: null
            }
          ]}
          PageName=' تفاصيـل طلب الشراء'
        />

        <div className='ms-auto'>
          <div className='col-5 col-md-6 text-end'>
            <ButtonPrint
              // PrintTemplateTypeId='868E12B7-A5D3-41F9-AA87-45BB552B3AAB' // قوالب طلب شراء
              PrintTemplateTypeId='9C4B0362-6E21-44F5-B255-68213EE1BBA7' // قوالب طلب شراء
              ReferenceId={id || ''}
            />
          </div>
        </div>
      </div>

      <Form onSubmit={formik.handleSubmit}>
        <Card className='shadow mb-3'>
          <Loading loading={loading3 || loading5}>
            <CardBody>
              <div className='row'>
                <div className='col-lg-3'>
                  <div className='form-group flex-nowrap mb-3'>
                    <label className='form-label'>{t('رقم طلب الشراء')}</label>

                    <div className='input-group flex-nowrap'>
                      <Form.Control
                        readOnly
                        className='form-control fw-bold text-center fs-5 text-theme'
                        type='text'
                        autoComplete='off'
                        onChange={formikhandleChange}
                        value={values.code || ''}
                        isInvalid={!!(touched.code && errors.code)}
                      />
                    </div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('الفئة')}</label>
                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={loading4}
                      // isSearchable={true}
                      // isClearable
                      options={CategoriesOptions}
                      value={CategoriesOptions?.find(
                        f => f.value?.toLowerCase() === formik.values.categoryId?.toLowerCase()
                      )}
                      // onChange={(option: any) => {
                      //   formik.setFieldValue('categoryId', option === null ? null : option.value);
                      // }}
                      // placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    <div className='text-danger'>{formik.errors.categoryId}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('تاريخ طلب الشراء')}</label>
                    <Form.Control
                      className='form-control  text-center'
                      type='date'
                      name='transactionDate'
                      onChange={formikhandleChange}
                      value={values.transactionDate || ''}
                      isInvalid={!!(touched.transactionDate && errors.transactionDate)}
                    />
                    <div className='text-danger'>{formik.errors.transactionDate}</div>
                  </div>
                </div>
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('تاريخ التوريد')}</label>
                    <Form.Control
                      className='form-control  text-center'
                      type='date'
                      name='deliveryDate'
                      onChange={formikhandleChange}
                      value={values.deliveryDate || ''}
                      isInvalid={!!(touched.deliveryDate && errors.deliveryDate)}
                    />
                  </div>
                </div>
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    {/* <label className="form-label">{t('الفرع')}</label> */}
                    <label className='form-label'>{t('الوحدة التشغيليـة')}</label>

                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={loading3}
                      isSearchable={true}
                      isClearable
                      options={OperatingUnitOptions}
                      value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
                      // onChange={(option: any) => {
                      //   formik.setFieldValue(
                      //     'organizationId',
                      //     option === null ? null : option.value
                      //   );
                      // }}
                      onChange={(option: any) => {
                        formik.setFieldValue('inventoryId', '');
                        formik.setFieldValue('organizationId', option?.value || '');
                      }}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    <div className='text-danger'>{formik.errors.organizationId}</div>
                  </div>
                </div>
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('المخزن')}</label>
                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={loading3}
                      isSearchable={true}
                      isClearable
                      options={InventoryOptions?.filter((f: any) => f.operatingUnitId === formik.values.organizationId)}
                      // options={InventoryOptions}
                      // value={InventoryOptions?.find(
                      //   (f: any) => f.value === formik.values.inventoryId
                      // )}
                      value={
                        formik.values.inventoryId &&
                        InventoryOptions?.find((f: any) => f.value === formik.values.inventoryId)
                      }
                      onChange={(option: any) => {
                        formik.setFieldValue('inventoryId', option === null ? null : option.value);
                      }}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    <div className='text-danger'>{formik.errors.inventoryId}</div>
                  </div>
                </div>

                <div className='col-lg-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Note')}</label>
                    <Form.Control
                      autoComplete='off'
                      className='form-control'
                      as='textarea'
                      rows={1}
                      name='description'
                      onChange={formik.handleChange}
                      value={values.description}
                      isInvalid={!!(touched.description && errors.description)}
                    />
                  </div>
                </div>
              </div>
            </CardBody>
          </Loading>
        </Card>

        <Card className='shadow mb-3'>
          <div>
            {Object.keys(data)?.length > 0 && (
              <>
                <PRLines formik={formik} isUpdate={true} />
              </>
            )}
            {formik.errors.transactionsLinesList?.length && <div className='text-danger'> * مطلوب </div>}
          </div>
        </Card>
        <Card className='p-2'>
          <div className='text-end'>
            <Can permission={'PUREditPurchaseRequests'}>
              <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg me-1 btn-theme mb-1 rounded-0'>
                {formik.isSubmitting ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className='fa fa-save fa-fw me-1'></i>
                )}

                {t('Save')}
              </button>
            </Can>
            <button
              type='button'
              className=' btn btn-lg me-1 btn-default mb-1 rounded-0'
              onClick={() => navigate('/PUR/PurchaseRequests', { replace: true })}
            >
              <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
            </button>
          </div>
        </Card>
      </Form>
    </div>
  );
};

export default Update;
